/**
 * Feedback System TypeScript SDK
 *
 * @packageDocumentation
 */

export { FeedbackClient } from "./client.js";
export { AuthClient } from "./auth.js";

// Export types
export type {
  ClientOptions,
  FeedbackData,
  FeedbackResponse,
  EventData,
  EventResponse,
  EventsResponse,
  EventLevel,
  LoginCredentials,
  LoginResponse,
  User,
  UserRole,
  FeedbackStatus,
  Feedback,
  Event,
  App,
  PaginationParams,
  FeedbackFilters,
  EventFilters,
  PaginatedResponse,
  FeedbackListResponse,
  EventListResponse,
  AppListResponse,
  CreateAppData,
  UpdateAppData,
  UpdateFeedbackStatusData,
  ChangePasswordData,
  CreateUserData,
  BootstrapAdminData,
} from "./types.js";

// Export errors
export {
  FeedbackError,
  ValidationError,
  AuthenticationError,
  AuthorizationError,
  NotFoundError,
  RateLimitError,
  NetworkError,
  ServerError,
} from "./errors.js";
